module.exports = __webpack_public_path__ + "media/shared/assets/fonts/InterDisplay/InterDisplay-ExtraBold-89518fa4ab7bacdb30e6bb414678e283.woff2";